/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const defaultLoaderState = { isVisible: false };

const defaultCustomLoaderState = {
  isVisible: false,
  content: '',
  heading: '',
  showUserName: false,
  overlay: false,
  show: false,
};

export const LoaderContext = React.createContext();

export default function LoaderContextProvider(props) {
  const { children } = props;
  const [loaderConfig, setLoaderConfig] = useState(defaultLoaderState);
  const [showUserName, setShowUserName] = useState(true);
  const [customLoaderConfig, setCustomLoaderConfig] = useState(
    defaultCustomLoaderState
  );
  const [isLoadingPage, setIsLoadingPage] = useState({
    isLoading: false,
    isLogin: false,
  });
  const [forwardcountertobuyer, setForwardCountertobuyer] = useState(false);
  return (
    <LoaderContext.Provider
      value={{
        loaderConfig,
        setLoaderConfig,
        customLoaderConfig,
        setCustomLoaderConfig,
        setShowUserName,
        showUserName,
        setIsLoadingPage,
        isLoadingPage,
        forwardcountertobuyer,
        setForwardCountertobuyer,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
}

LoaderContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
